import { $, $$ } from 'utils/dom';
import Filter from 'modules/Filter/filter';

const reviews = $$('.review');

if (reviews.length) {
  reviews.forEach(card => {
    if ($('.o-filter', card) || $('.review__btn button', card)) {
      new Filter({
        container: card,
        filter: $('.o-filter', card),
        items: $$('.review__item', card),
        hiddenClass: 'review__item--hidden',
        activeClass: 'review__item--active',
        itemLinkClassName: '.review__link', // optional: only for a-tags, so hidden items cant be focused via keyboard
        loadMoreNode: $('.review__btn button', card), // optional: only if you have a load-more button
        defaultItemsToShow: 4, // optional: only active if you are using load-more button
        amountOfItemsToShow: 4, // optional: only active if you are using load-more button
      }).init();
    }
  });
}
